// Data access for the TVs. Deliberately simple (plain fetch, no libraries) so it runs on
// older Fire TV browsers. Changes are picked up by polling a tiny version number.
const { SUPABASE_URL, SUPABASE_ANON_KEY } = window.TM_CONFIG || {};

export const DEMO = !SUPABASE_URL || location.search.indexOf('demo') !== -1;
const DEMO_KEY = 'tm-demo-db';

function rest(path, opts) {
  opts = opts || {};
  return fetch(SUPABASE_URL.replace(/\/$/, '') + '/rest/v1/' + path, {
    method: opts.method || 'GET',
    headers: { apikey: SUPABASE_ANON_KEY, 'Content-Type': 'application/json' },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
    cache: 'no-store',
  }).then((res) => {
    if (!res.ok) throw new Error('Server said ' + res.status);
    return res.status === 204 ? null : res.json();
  });
}

let demoSeed = null;
function demoDb() {
  try {
    const saved = JSON.parse(localStorage.getItem(DEMO_KEY));
    if (saved && saved.restaurants) return Promise.resolve(saved);
  } catch (e) { /* fall through */ }
  if (demoSeed) return Promise.resolve(demoSeed);
  return fetch('../demo/seed.json').then((r) => r.json()).then((d) => { demoSeed = d; return d; });
}

/** Rows of `table` where every key in `eq` matches. */
export function select(table, eq) {
  eq = eq || {};
  const keys = Object.keys(eq);
  if (DEMO) {
    return demoDb().then((d) => d[table].filter((r) => keys.every((k) => r[k] === eq[k])));
  }
  const filter = keys.map((k) => '&' + k + '=eq.' + encodeURIComponent(eq[k])).join('');
  return rest(table + '?select=*' + filter);
}

/** A number that goes up whenever this restaurant's menu, prices or screens change. */
export function version(restaurantId) {
  if (DEMO) return demoDb().then((d) => d.version || 0);
  return rest('menu_version?select=version&restaurant_id=eq.' + restaurantId).then((rows) => (rows[0] ? rows[0].version : 0));
}

export function heartbeat(code, info) {
  if (DEMO) return Promise.resolve();
  return rest('rpc/screen_heartbeat', { method: 'POST', body: { p_code: code, p_info: info } });
}

/** Demo only: another tab (the admin) changed the data. */
export function onDemoChange(cb) {
  if (DEMO) window.addEventListener('storage', (e) => { if (e.key === DEMO_KEY) cb(); });
}
